module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/193-norfolk-island-ef77c2c8b22efc787ac380ad089a201f.svg";